<div *ngIf="!documentProxy || loadPreference" class="globalLoading position-fixed w-100 h-100 fix-parent-height-center-center" style="transition: all .3s; display: flex !important;">
  <span class="loader"></span>
</div>

<mat-toolbar class="toolbar main-toolbar" color="primary" #pdfToolbar>
  <mat-toolbar-row class="flex nav-desktop top-toolbar">

    <div class="top-toolbar-start">
      <button mat-icon-button (click)="onCloseViewer()"  matTooltip="{{ 'GLOBAL.BACK' | translate }}">
        <i class="rt-icon rt-cerrar fs22"></i>
      </button>
    </div>

    <div class="top-toolbar-center">
      <div class="">
        <img src="assets/images/logo/{{theme}}/logo_signtrust_white.svg" class="logo" alt="brand_logo" />
      </div>
    </div>

    <div class="top-toolbar-end">
      <button
        *ngIf="documentProxy"
        mat-icon-button
        class=""
        matTooltip="{{ 'WEB-SIGN.SIGNTRUST-LIB.FLOATING-MENU.DOWNLOAD' | translate }}"
        (click)="onDownloadDocumentButtonClick()">
        <i class="rt-icon rt-archivo-1 fs25"></i>
      </button>

      <button mat-icon-button (click)="openDocumentInfoClick()"  matTooltip="{{ 'WEB-SIGN.SIGNTRUST-LIB.DOC-INFO.TITLE' | translate }}">
        <i class="rt-icon rt-info fs25"></i>
      </button>
    </div>
  </mat-toolbar-row>
</mat-toolbar>

<div class="pdf-control-toolbar">
  <!-- floating pagination -->
  <div class="top-toolbar" [style]="{top: (pdfTopHeight+5)+'px !important'}" [hidden]="totalPages <= 1 || !documentProxy || !showPagination">
    <button
      mat-icon-button
      [disabled]="page <= 1"
      matTooltip="{{ 'WEB-SIGN.SIGNTRUST-LIB.FLOATING-MENU.FIRST-PAGE' | translate }}"
      (click)="firstPage()">
      <mat-icon>first_page</mat-icon>
    </button>
    <button
      mat-icon-button
      [disabled]="page <= 1"
      matTooltip="{{ 'WEB-SIGN.SIGNTRUST-LIB.FLOATING-MENU.PREVIOUS-PAGE' | translate }}"
      (click)="prevPage()">
      <mat-icon>navigate_before</mat-icon>
    </button>

    <span>{{ page }} / {{ totalPages }}</span>

    <button
      mat-icon-button
      [disabled]="page === totalPages || page < 1"
      matTooltip="{{ 'WEB-SIGN.SIGNTRUST-LIB.FLOATING-MENU.NEXT-PAGE' | translate }}"
      (click)="nextPage()">
      <mat-icon>navigate_next</mat-icon>
    </button>
    <button
      mat-icon-button
      [disabled]="page === totalPages || page < 1"
      matTooltip="{{ 'WEB-SIGN.SIGNTRUST-LIB.FLOATING-MENU.LAST-PAGE' | translate }}"
      (click)="lastPage()">
      <mat-icon>last_page</mat-icon>
    </button>
  </div>

  <!-- floating sign action -->
  <div class="center-toolbar" *ngIf="documentProxy && showSignButton && certificateList">
    <div class="btn-group" role="group">
      <button class="btn btn-success btn-float-confirm-sign"
      mat-icon-button
      matTooltip="{{ 'WEB-SIGN.SIGNTRUST-LIB.FLOATING-MENU.SIGN-DOCUMENT' | translate }}"
      [disabled]="sendData"
      (click)="onSelectCertificate('no-visual')">
      <i class="rt-icon rt-cheque fs35"></i>
      </button>
    </div>

    <div class="btn-group ms-2" role="group">
      <button class="btn btn-info btn-float-edit-sign"
      mat-icon-button
      matTooltip="{{ 'WEB-SIGN.SIGNTRUST-LIB.FLOATING-MENU.EDIT-SIGN-CONFIG' | translate }}"
      [disabled]="sendData"
      (click)="onEditSignature()">
      <i class="rt-icon rt-editar fs35"></i>
      </button>
    </div>
  </div>
</div>

<div class="panel-pdf-notify" [hidden]="hidePDFNotify" #pdfNotify *ngIf="certificateList">
  <!-- without select certificate -->
  <div class="notify notify-warning wb-ball" *ngIf="!hasSelectedCertificate">
    <span class="notify-message">
      <div class="notify-and-actions">
        <div class="">
          <b class="fw-bold">{{ 'WEB-SIGN.SIGN-IMG.LABELS.NO-SELECT-CERTIFICATE' | translate }}</b>
        </div>
        <div class="d-flex">
          <button mat-stroked-button (click)="onSelectCertificate('current')" color="primary">
            <i class="rt-icon rt-upload-certificate" *ngIf="isMobile"></i>
            <span *ngIf="!isMobile">{{ 'WEB-SIGN.SIGN-IMG.LABELS.CERT-SELECT' | translate }}</span>
          </button>
          <i (click)="closeNotify()" class="rt-icon rt-cerrar and-text pointer ms-2"></i>
        </div>
      </div>
    </span>
  </div>
  <!-- with select certificate -->
  <div class="notify notify-success wb-ball" *ngIf="hasSelectedCertificate">
    <span class="notify-message">
      <div class="notify-and-actions">
        <div class="">
          <b class="fw-bold">{{ 'WEB-SIGN.SIGN-IMG.LABELS.SELECT-CERTIFICATE' | translate }}</b> "{{selectCertificate?.alias}} - {{ 'WEB-SIGN.SIGNTRUST-LIB.CERTIFICATES-LIST.CARD.ISSUER' | translate }}&nbsp;{{selectCertificate?.issuer}} - {{ 'WEB-SIGN.SIGNTRUST-LIB.CERTIFICATES-LIST.CARD.EXPIRES' | translate }}&nbsp;{{selectCertificate?.expiration | dateMultiLang: 'currentLang':'small' }}".
        </div>
        <div class="d-flex">
          <button mat-stroked-button (click)="onSelectCertificate('current')" color="primary">
            <i class="rt-icon rt-repeat" *ngIf="isMobile"></i>
            <span *ngIf="!isMobile">{{ 'GLOBAL.CHANGE' | translate }}</span>
          </button>
          <i (click)="closeNotify()" class="rt-icon rt-cerrar and-text pointer ms-2"></i>
        </div>
      </div>
    </span>
  </div>
</div>

<div id="imgTemplate" class="currentSignTemplate" *ngIf="(base64Image || metadataCertificate || useCustomImg) && certificateList">
  <div class="template-content">
    <div class="p-0 img-template-content me-1" *ngIf="useCustomImg">
      <img
        class="img-template"
        height="60"
        [src]="base64Image ? (base64Image | domSanitizer: 'url') : 'assets/images/icons/no-img.png'"
        crossorigin="anonymous"
        alt="" />
    </div>
    <div class="p-0 metadata-template-content" *ngIf="metadataCertificate">
      <div *ngIf="metadataSelection?.[0]?.check">
        <span class="fw-bold">{{metadataSelection?.[0]?.name}}: </span>
        <span *ngIf="selectCertificate?.alias">{{selectCertificate?.alias}}</span>
        <span *ngIf="!selectCertificate?.alias">{{'WEB-SIGN.SIGN-IMG.LABELS.CERT-SUBJECT-EXAMPLE' | translate}}</span>
      </div>
      <div *ngIf="metadataSelection?.[1]?.check">
        <span class="fw-bold">{{metadataSelection?.[1]?.name}}: </span>
        <span>{{username}}</span>
      </div>
      <div *ngIf="metadataSelection?.[2]?.check">
        <span class="fw-bold">{{metadataSelection?.[2]?.name}}: </span>
        <span>{{currentDate | dateMultiLang:currentLang}}</span>
      </div>
      <div *ngIf="metadataSelection?.[3]?.check">
        <span class="fw-bold">{{metadataSelection?.[3]?.name}}: </span>
        <small *ngIf="selectCertificate?.thumbprint">{{selectCertificate?.thumbprint}}</small>
        <span *ngIf="!selectCertificate?.thumbprint">{{'WEB-SIGN.SIGN-IMG.LABELS.CERT-THUMBPRINT-EXAMPLE' | translate}}</span>
      </div>
    </div>
  </div>
</div>

<div class="pdf-control-container">
  <!-- RENDER PDF VIEWER -->
  <pdf-viewer
    #pdfViewer
    *ngIf="documentFile && documentFile | fileToBase64 | async as documentSrc"
    class="pdf-viewer"
    [src]="documentSrc"
    [rotation]="0"
    [show-all]="false"
    [(page)]="page"
    [fit-to-page]="false"
    [original-size]="false"
    [zoom-scale]="adjustViewPort"
    [zoom]="zoom"
    [stick-to-page]="false"
    [render-text]="true"
    [render-text-mode]="1"
    [external-link-target]="'blank'"
    [autoresize]="true"
    [show-borders]="false"
    (after-load-complete)="afterLoadComplete($event)"
    (page-rendered)="pageRendered($event)"
    (error)="onError($event)"
    [style.height]="dynamicPdfHeight">
  </pdf-viewer>

  <!-- RESIZABLE DRAGGABLE TEMPLATE -->
  <div
    *ngIf="templateImageFile && documentRect && certificateList"
    [style.width.px]="documentRect.width"
    [style.height.px]="documentRect.height"
    class="dragzone-container document-boundary position-absolute top-0 left-0 right-0 mx-auto overflow-hidden"
    >
    <div
      #signArea
      class="draggable-box"
      [style.width.px]="dragZoneDimension.width"
      [style.height.px]="dragZoneDimension.height"
      [style.min-width.px]="60"
      [style.min-height.px]="60"
      cdkDrag
      [cdkDragFreeDragPosition]="dragZoneCoord"
      cdkDragBoundary=".dragzone-container"
      (cdkDragStarted)="onSignAreaDragStart($event)"
      (cdkDragEnded)="onSignAreaDragEnd($event)"
      color="primary">
      <!-- CONFIRM / EDIT BUTTONS -->
      <div
        #confirmEditButtons
        class="btn-toolbar confirm-cancel"
        [ngClass]="calculateButtonsPosition()"
        role="toolbar">
        <!-- confirm -->
        <div class="btn-group" role="group">
          <button
            type="button"
            class="btn btn-sign-tools btn-success"
            [matTooltip]="'WEB-SIGN.SIGNTRUST-LIB.FLOATING-MENU.SIGN-DOCUMENT' | translate"
            [disabled]="sendData"
            (click)="onSelectCertificate('signing')">
            <i class="rt-icon rt-cheque fs24"></i>
          </button>
        </div>

        <!-- tools actions & edit -->
        <div class="btn-group ms-2" role="group">
          <button
            type="button"
            class="btn btn-sign-tools btn-info text-white"
            [matTooltip]="'WEB-SIGN.SIGNTRUST-LIB.FLOATING-MENU.EDIT-SIGN-CONFIG' | translate"
            [disabled]="sendData"
            (click)="onEditSignature()">
            <i class="rt-icon rt-editar fs24"></i>
          </button>

          <button
            type="button"
            class="btn btn-sign-tools btn-secondary"
            [matTooltip]="'WEB-SIGN.SIGNTRUST-LIB.FLOATING-MENU.ROTATE-R' | translate"
            *ngIf="templateImageFile"
            (click)="rotate(90)">
            <i class="rt-icon rt-rotate-right"></i>
          </button>
        </div>
      </div>
      <!-- BOX RESIZE CORNER -->
      <span #dragHandleCorner class="resize-corner" cdkDrag (cdkDragMoved)="onSignAreaResize(dragHandleCorner, $event)">
      </span>
      <img
        [hidden]="loadingImg || !templateImageFile"
        #signImg
        id="signImg"
        *ngIf="templateImageFile"
        [src]="templateImageFile | domSanitizer: 'url'"
        class="img-fluid sign-img"
        alt="signing_image" />
        <i class="fas fa-spinner fa-pulse fa-1x center-spinner" *ngIf="loadingImg || !templateImageFile"></i>
    </div>
  </div>
</div>
